import {
  CreateProductEntity,
  ProductEntity,
} from '@/pages/privatePages/product/types';
import { BaseService } from './base.service';
import { QueryFunctionContext } from '@tanstack/react-query';
import { newQueryKeys } from '@/queries/queryKeys';
import APIService from './axios.service';
import { CustomResponse } from './type';
import { SignedUrlPayload } from '@/queries/user.query';

export type ProductCountByQuantityParams = {
  // Both bounds inclusive, integers >= 0
  quantityFrom?: number;
  quantityTo?: number;
  // Omit to count both active and inactive products
  active?: boolean;
};

class ProductServiceClass extends BaseService<
  'product',
  ProductEntity,
  CreateProductEntity
> {
  constructor() {
    super('products');
  }

  getProductInventorySummary = (
    context: QueryFunctionContext<
      ReturnType<(typeof newQueryKeys)[keyof typeof newQueryKeys]['list']>
    >,
  ): Promise<CustomResponse<ProductEntity[]>> => {
    const { params } = context.queryKey[0];
    return APIService.get('/products/inventory-summary', { params });
  };

  countByQuantity = (
    params: ProductCountByQuantityParams,
  ): Promise<{ count: number }> => {
    return APIService.get('/products/count-by-quantity', { params });
  };

  generateManySignedUrl = (files: SignedUrlPayload[]) => {
    return APIService.post('/products/upload-urls', files);
  };
}

export const productService = new ProductServiceClass();
